import { FoodsIcon } from "@foodpilot/foods";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { URLHandler } from "src/services/URLHandler";
import { DIAGNOSTIC_COLOR_INDEX } from "..";

type SeeDetailsButtonProps = {
    metaForUrl: {
        companyId: number;
        ssqId: number;
        campaignId: number;
        scoreId: string;
    };
    isComplete: boolean;
    // to: string;
};

export const EmphasizedButton = (props: SeeDetailsButtonProps) => {
    const { t } = useTranslation();

    const {
        metaForUrl: { companyId, ssqId, campaignId, scoreId },
        isComplete,
    } = props;

    if (isComplete) {
        const to = URLHandler.company.ssqScore(companyId, ssqId, campaignId, Number(scoreId));
        return (
            <Link to={to}>
                <Button
                    variant={`dataviz-${DIAGNOSTIC_COLOR_INDEX}`}
                    startIcon={<FoodsIcon size={2} icon={"analyzeData"} />}
                    sx={{
                        width: "100%",
                    }}
                >
                    {t("company.dashboard.go_to_details", `See details`)}
                </Button>
            </Link>
        );
    }

    const to = URLHandler.company.questionnaireScore(companyId, ssqId, campaignId, scoreId);
    return (
        <Link to={to}>
            <Button
                variant={`dataviz-${DIAGNOSTIC_COLOR_INDEX}`}
                startIcon={<FoodsIcon size={2} icon={"questionnaireAnswer"} />}
                sx={{ width: "100%" }}
            >
                {t("diagnostic.complete_questionnaire")}
            </Button>
        </Link>
    );
};
